import { CoreInterfaces, DTOs } from "src/core/Models";
import * as Constants from "./../core/Constants";
import { findQuestionInService } from "./shared";
import { applyUpdatesOnQuestionChange } from "./processors/Questions";

export function updateQuestionInService(
  services: Array<DTOs.ServiceDTO>,
  question: DTOs.QuestionDTO,
  serviceCode: Constants.ServiceCode
) {
  return services.map((service) =>
    service.data.code === serviceCode
      ? {
          ...service,
          data: {
            ...service.data,
            questions: service.data.questions.map((eachQuestion) =>
              eachQuestion.data.code === question.data.code
                ? question
                : eachQuestion
            ),
          },
        }
      : service
  );
}

export function buildNextState(
  state: CoreInterfaces.AppState,
  nextStateQuestion: DTOs.QuestionDTO,
  serviceToUpdate: Constants.ServiceCode
) {
  const updatedServices = updateQuestionInService(
    state.services,
    nextStateQuestion,
    serviceToUpdate
  );
  const nextState = { ...state, services: updatedServices };
  applyUpdatesOnQuestionChange(
    nextState,
    updatedServices.find((service) => service.data.code === serviceToUpdate)
  );
  return nextState;
}

export function handleEngagementMetadataResetWhenConfigurationChange(
  oldState: CoreInterfaces.AppState,
  newState: CoreInterfaces.AppState
): void {
  let shouldResetEngagementLetterMetadata = false;
  const oldService10 = oldState.services.find(
    (s) => s.data.code === Constants.ServiceCode.EngagementCounseling
  );
  const newService10 = newState.services.find(
    (s) => s.data.code === Constants.ServiceCode.EngagementCounseling
  );
  if (oldService10 && newService10) {
    if (oldService10.state.isSelected !== newService10.state.isSelected) {
      shouldResetEngagementLetterMetadata = true;
    } else {
      const oldGeneralService = oldState.services.find(
        (s) => s.data.code === Constants.ServiceCode.GeneralInformation
      );
      const newGeneralService = newState.services.find(
        (s) => s.data.code === Constants.ServiceCode.GeneralInformation
      );
      if (newService10.state.isSelected) {
        const oldQuestion40 = findQuestionInService(
          oldGeneralService,
          Constants.GeneralInformationQuestion.Q0040
        );
        const newQuestion40 = findQuestionInService(
          newGeneralService,
          Constants.GeneralInformationQuestion.Q0040
        );
        if (oldQuestion40.data.userValue !== newQuestion40.data.userValue) {
          shouldResetEngagementLetterMetadata = true;
        }
      } else {
        const oldQuestion22 = findQuestionInService(
          oldGeneralService,
          Constants.GeneralInformationQuestion.Q0022
        );
        const newQuestion22 = findQuestionInService(
          newGeneralService,
          Constants.GeneralInformationQuestion.Q0022
        );
        if (
          oldQuestion22.state.isShown !== newQuestion22.state.isShown ||
          oldQuestion22.data.userValue !== newQuestion22.data.userValue
        ) {
          shouldResetEngagementLetterMetadata = true;
        }
      }
    }
  }
  if (shouldResetEngagementLetterMetadata) {
    newState.currentConfiguration.engagementLetterMetadata = null;
  }
}

export function applyChangesTimestampOnNextState(
  nextState: CoreInterfaces.AppState
): void {
  const currentDate = new Date();
  nextState.areUnsavedChanges = true;
  nextState.unsavedChangesTimestamp = currentDate.getTime();
  if (nextState.currentConfiguration) {
    nextState.currentConfiguration.lastUserChangesDate = currentDate;
  }
}
